import { Box, styled} from '../../../ui-library';

export const InputsBox = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    height: 100%;
    justify-content: center;
    width: 100%;
`;
